import React, { useState, useEffect } from "react";
import { FiFileText, FiLock } from "react-icons/fi";
import "./ComplianceSection.css";
import Book from "../components/Book";

import Modal from "react-modal";

const ComplianceSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [active, setActive] = useState(false);
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    const originalPadding = window.getComputedStyle(document.body).paddingRight;

    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalStyle;
      document.body.style.paddingRight = originalPadding;
    }

    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.paddingRight = originalPadding;
    };
  }, [isModalOpen]);

  const handleClick = (link) => {
    if (link) {
      setModalContent(
        "The data will be available shortly. Please check back later."
      );
      setActive(true);
    } else {
      setModalContent(
        "This document is currently unavailable or confidential."
      );
      setActive(false);
    }
    document.body.style.overflow = "hidden";
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    document.body.style.overflow = "";
    setIsModalOpen(false);
  };
  const standardsData = [
    {
      number: "TSG 71-2023",
      title:
        "Regulation on Safety Technology for Large-scale Amusement Rides and Devices",
      link: "4_1_TSG 71-2023.html",
    },
    {
      number: "GB 8408-2018",
      title: "Large-scale Amusement Device Safety Code",
      link: "",
    },
    {
      number: "GB/T 18158-2019",
      title: "Specifications of Amusement Rides Merry-Go-Round Category",
      link: "",
    },
    {
      number: "GB/T 18159-2019",
      title: "Specifications of Amusement Rides Coaster Category",
      link: "",
    },
    {
      number: "GB/T 18160-2020",
      title: "Specifications of Amusement Rides Space Gyro Category",
      link: "",
    },
    {
      number: "GB/T 18161-2020",
      title: "Specifications of Amusement Rides Fly Tower Category",
      link: "",
    },
    {
      number: "GB/T 18162-2020",
      title: "Specifications of Amusement Rides Fairy Racing Category",
      link: "",
    },
    {
      number: "GB/T 18163-2020",
      title: "Specifications of Amusement Rides Astro Fighter Category",
      link: "",
    },
    {
      number: "GB/T 18164-2020",
      title: "Specifications of Amusement Rides Wonder Wheel Category",
      link: "",
    },
    {
      number: "GB/T 18165-2020",
      title: "Specifications of Amusement Rides Fairy Train Category",
      link: "",
    },
    {
      number: "GB/T 18166-2020",
      title: "Specifications of Amusement Rides Monorail Category",
      link: "",
    },
    {
      number: "GB/T 18167-2020",
      title: "Specifications of Amusement Rides Shooting Category",
      link: "",
    },
    {
      number: "GB/T 18168-2017",
      title: "Specifications of Water Amusement Equipment Category",
      link: "",
    },
    {
      number: "GB/T 18169-2020",
      title: "Specifications of Amusement Rides Bumper Car Category",
      link: "",
    },
    {
      number: "GB/T 31258-2014",
      title: "Specifications of Zip Line",
      link: "",
    },
    {
      number: "GB/T 37219-2023",
      title: "Safety Specification of Inflatable Play Equipment",
      link: "",
    },
    {
      number: "GB/T 34370.1-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 1: General Requirements",
      link: "",
    },
    {
      number: "GB/T 34370.2-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 2: Visual Examination",
      link: "",
    },
    {
      number: "GB/T 34370.3-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 3: Magnetic Particle Testing",
      link: "",
    },
    {
      number: "GB/T 34370.4-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 4: Penetrant Testing",
      link: "",
    },
    {
      number: "GB/T 34370.5-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 5: Ultrasonic Testing",
      link: "",
    },
    {
      number: "GB/T 34370.6-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 6: Radiographic Testing",
      link: "",
    },
    {
      number: "GB/T 34370.7-2017",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 7: Eddy Current Testing",
      link: "",
    },
    {
      number: "GB/T 34370.8-2020",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 8: Acoustic Emission Testing",
      link: "",
    },
    {
      number: "GB/T 34370.9-2020",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 9: Magnetic Flux Leakage Testing",
      link: "",
    },
    {
      number: "GB/T 34370.10-2020",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 10: Magnetic Memory Testing",
      link: "",
    },
    {
      number: "GB/T 34370.11-2020",
      title:
        "Nondestructive Testing of Amusement Equipments - Part 11: Ultrasonic Guided Wave Testing",
      link: "",
    },
    {
      number: "GB/T 39079-2020",
      title:
        "Inspection and Testing Specifications of Large-scale Amusement Device - General Principles",
      link: "",
    },
    {
      number: "GB/T 39079-2020",
      title:
        "Inspection and Test Specifications of Large-scale Amusement Device - Acceleration Test",
      link: "",
    },
  ];

  return (
    <section
      className="GB-compliance-section"
      style={{
        backgroundImage: `url(${require("../assets/image/E4bg.png")})`,
      }}
    >
      <div className="GB-container">
        <div className="GB-header">
          <h2 className="GB-title">GB Compliance Standards</h2>
        </div>

        <div className="GB-table-wrapper">
          <table className="GB-compliance-table">
            <thead>
              <tr>
                <th title="Standard Number">Std. No.</th>
                <th title="Description">Desc.</th>
                <th title="Documentation">Doc.</th>
              </tr>
            </thead>
            <tbody>
              {standardsData.map((item, index) => (
                <tr key={index}>
                  <td className="GB-standard-number">{item.number}</td>
                  <td className="GB-description">{item.title}</td>
                  <td className="GB-documentation">
                    <button
                      className={`GB-doc-link ${
                        item.link ? "available" : "unavailable"
                      }`}
                      onClick={() => handleClick(item.link)}
                    >
                      {item.link ? <FiFileText /> : <FiLock />}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        className="Modal-content"
        overlayClassName="Modal-overlay"
        ariaHideApp={false}
      >
        {!active && (
          <>
            <h2>Document Information</h2>
            <p>{modalContent}</p>
          </>
        )}

        <button className="Modal-close-btn" onClick={handleCloseModal}>
          X
        </button>

        {active && <Book />}
      </Modal>
    </section>
  );
};

export default ComplianceSection;
